import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '@components/common/Button';
import CustomTooltip from '@components/common/CustomTooltip';
import InfoBar from '@components/common/InfoBars';
import profilePic from '../../../../../assets/png/default_profile.png';
import './ProfilePicUpdateModal.css';
import EditIcon from '../../../../../assets/svg_main/pencil-01.svg';


interface ProfilePicUpdateModalProps {
  showModal: boolean;
  onClose: () => void;
  modalTitle: string;
  imageUrl: string;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleProfilePicSubmit: () => void;
  imageError: string;
  inputRef: React.RefObject<any>;
}

const ProfilePicUpdateModal: React.FC<ProfilePicUpdateModalProps> = ({
  showModal,
  onClose,
  modalTitle,
  imageUrl,
  handleFileChange,
  handleProfilePicSubmit,
  imageError,
  inputRef,
}) => {
  const buttonName = imageUrl ? 'Edit Profile Picture' : '+ Add Profile Picture';
  const icon = imageUrl ? <EditIcon /> : '';

  return (
    <div className="profile-update-modal">
      <Modal
        show={showModal}
        onHide={onClose}
        dialogClassName={'profile-update-modal'}
        centered={true}
        backdrop = "static"
      >
        <Modal.Body>
          <div className="profile-update-modal-body-header">
            <div className="modal-body-back" onClick={onClose}>
              <i className="bi bi-arrow-left"></i>
              <span className="ms-1">Back</span>
            </div>
            <div className="modal-body-discard" onClick={onClose}>
              <span className="me-0">Discard</span>
              <i className="bi bi-x"></i>
            </div>
          </div>
          <div className="profile-update-modal-profile-picture">
            <h1>{modalTitle}</h1>
            <div className="profile-picture-container">
              <div className="modal-image">
                {imageUrl ? (
                  <img className="profile-picture" src={imageUrl} alt="Profile Image" />
                ) : (
                  <img className="profile-picture" src={profilePic} alt="Profile Image" />
                )}
              </div>
              <div className="add-profile-container">
                <div className="profile-buttons">
                  <Button
                    onClick={() => inputRef.current?.click()}
                    disabled={false}
                    id="add-profile-picture"
                    buttonName={buttonName}
                    colorType={'primary'}
                    icon={icon}
                    iconPosition={'left'}
                  />
                  <span className="tooltip-profile-pic">
                    <CustomTooltip text={'File size must be less than or equal to 1MB and Only JPG, JPEG and PNG images are allowed'} />
                  </span>
                </div>
                {imageError.length > 0 && (
                  <InfoBar variant="danger" message={imageError} className="input_field_class profile-pic-error" />
                )}
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  onChange={handleFileChange}
                  className="profile-picture-hidden-input"
                  ref={inputRef}
                />
              </div>
            </div>
            <div className="profile-update-button">
              <Button
                onClick={handleProfilePicSubmit}
                disabled={false}
                id=""
                buttonName={'Upload'}
                colorType={'primary'}
                icon={''}
                iconPosition={''}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProfilePicUpdateModal;